package com.arena_web.ui.localization

import com.arena_web.data.http.isNetworkError

/**
 * Maps a failed upload/API call to user-facing text: transport failures become
 * the localized connection error (never the browser's raw "Failed to fetch"),
 * everything else keeps the throwable's message. Composables pass [strings]
 * from LocalAppStrings; view models rely on the [currentAppStrings] default.
 */
fun uploadErrorMessage(
    e: Throwable?,
    strings: AppStrings = currentAppStrings(),
    fallback: String? = null,
): String? = when {
    e == null -> fallback
    e.isNetworkError() -> strings.commonErrorConnection
    else -> e.message ?: fallback
}
